import { lazy } from '@loadable/component';

const BookingHistory = lazy(() =>
  import(
    /* webpackChunkName: "booking_history" */
    './booking_history'
  )
);

export default BookingHistory;
